import { resolveMetricDisplayName } from "@/utils/formatting/format-metric-display-results"

import type { RunResultsMetricRenderAdaptersById } from "../types"

/**
 * Display label for a metric column. In compact mode, abbreviates to initials
 * (multi-word) or truncates a long single word; otherwise shows the full name.
 */
export function getMetricDisplayLabel(
  metricKey: string,
  isCompact: boolean,
  metricRenderAdaptersById: RunResultsMetricRenderAdaptersById,
): string {
  const fullName = resolveMetricDisplayName(
    metricRenderAdaptersById[metricKey]?.metric_display_name,
    metricKey,
  )

  if (!isCompact) {
    return fullName
  }

  const words = fullName.split(/[\s_-]+/)
  if (words.length > 1) {
    return words
      .map((w) => w[0])
      .join("")
      .toUpperCase()
  } else if (fullName.length > 8) {
    return `${fullName.substring(0, 6)}...`
  }
  return fullName
}
